const aspectRatioStrings = {
  Image191x100: '191X100',
  Image4x1: '400X100',
  Image1x1: '100X100',
  Image1x2: '50X100',
  Image178x100: '178X100',
  Image172x100: '172X100',
  Image169x100: '169X100',
  Image150x100: '150X100',
  Image155x100: '155X100',
  Image133x100: '133X100',
  Image93x100: '93X100',
  Image201x100: '201X100',
  Image200x100: '200X100',
  Image153x100: '153X100',
  Image124x100: '124X100',
  Image120x100: '120X100',
};

const aspectRationStringsForPmax = {
  Image191x100: 'AssetGroup191X100',
  Image4x1: 'AssetGroup400X100',
  Image1x1: 'AssetGroup100X100',
  Image1x2: 'AssetGroup100X200',
  Image178x100: 'AssetGroup178X100',
  Image150x100: 'AssetGroup150X100',
  Image133x100: 'AssetGroup133X100',
};

const aspectRationStringsForPmaxV2 = {
  Image191x100: 'AssetGroup191X100',
  Image4x1: 'AssetGroup400X100',
  Image1x1: 'AssetGroup100X100',
  Image1x2: 'AssetGroup100X200',
  Image201x100: 'MSAN201X100',
  Image169x100: 'MSAN169X100',
  Image153x100: 'MSAN153X100',
  Image124x100: 'MSAN124X100',
};

export const getMediaPlacementType = ({
  isMultimediaAd,
  isMultimediaAdinMSANEnabled,
  isCombinedMsanAndMmaAspectRatios,
  isPMaxAspectRatiosV2Enabled,
  type,
}) => {
  if (isCombinedMsanAndMmaAspectRatios) {
    return isPMaxAspectRatiosV2Enabled
      ? `${aspectRationStringsForPmaxV2[type]}`
      : `${aspectRationStringsForPmax[type]}`;
  }
  let adType = 'ImageExtension';
  if (isMultimediaAd) {
    adType = 'MultiMediaAd';
  } else if (isMultimediaAdinMSANEnabled) {
    adType = 'MSAN';
  }

  return `${adType}${aspectRatioStrings[type]}`;
};

